import React from 'react';
import { Tabs } from 'antd';
const { TabPane } = Tabs;
import styles from './styles.module.scss';

import ResetContentProgress from '$components/Admin/Tasks/ResetContentProgress';
import ResetMemoryProgress from '$components/Admin/Tasks/ResetMemoryProgress';
import ResetExams from '$components/Admin/Tasks/ResetExams';
import ResetEssays from '$components/Admin/Tasks/ResetEssays';
import UnlockCourse from '$components/Admin/Tasks/UnlockCourse';

const AdminTabs = (props) => {
  const { subscriptions } = props;

  return (
    <Tabs defaultActiveKey="1">
      {subscriptions.map((subscription, index) => {
        const { product, userUuid } = subscription;
        const { slug: productSlug } = product;

        return (
          <TabPane className={styles.tabPane} tab={product.name} key={index + 1}>
            <ResetContentProgress productSlug={productSlug} userUuid={userUuid} />
            <ResetMemoryProgress productSlug={productSlug} userUuid={userUuid} />
            {productSlug === 'gre' && (
              <ResetEssays productSlug={productSlug} userUuid={userUuid} />
            )}
            <ResetExams productSlug={productSlug} userUuid={userUuid} />
            <UnlockCourse productSlug={productSlug} userUuid={userUuid} />
          </TabPane>
        );
      })}
    </Tabs>
  );
};

export default AdminTabs;
